/**
 * One vertical, infinitely-looping poster column used by the hero showcase.
 * The poster list is rendered twice back-to-back and animated by exactly
 * -50% of the track height, so the loop has no visible seam.
 *
 * Configurable per column: scroll `direction` ("up" | "down"), loop
 * `duration` (seconds), a negative `delay` (seconds) so columns don't start
 * in sync, and relative `weight` to vary poster size between columns.
 * Columns size with flex-grow (not a fixed px width) so the 3-column row
 * always fits its container — a `max-width` per size in CSS caps how wide
 * a column gets on very large screens.
 */
export default function PosterColumn({
    posters,
    direction = 'up',
    duration = 30,
    delay = 0,
    weight = 1,
    className = '',
}) {
    const loopItems = [...posters, ...posters];

    return (
        <div
            className={`poster-column ${className}`}
            style={{ flex: `${weight} 1 0%`, minWidth: 0 }}
        >
            <div
                className={`poster-column-track ${direction === 'down' ? 'poster-column-track-down' : 'poster-column-track-up'}`}
                style={{
                    animationDuration: `${duration}s`,
                    animationDelay: `${delay}s`,
                }}
            >
                {loopItems.map((poster, i) => (
                    <div className="poster-card" key={`${poster.alt}-${i}`}>
                        <img src={poster.src} alt={poster.alt || ''} loading="lazy" />
                        {poster.badge && (
                            <span className="poster-card-tag">{poster.badge}</span>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
